import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "interestsReceived";
const initialState = {
  interestsReceivedInd: [],
  interestsReceivedIns: [],
  loading: false,
  error: null,
};

export const interestsReceivedIndAPI = createAsyncThunk(
  "interestsreceivedind",
  async ({ search, skip, limit, id, type }) => {
    var formData = {};

    formData["id"] = id;
    formData["model"] = "Individual";

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }application/project-received?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

export const interestsReceivedInsAPI = createAsyncThunk(
  "interestsreceivedins",
  async ({ search, skip, limit, id, type }) => {
    var formData = {};

    formData["id"] = id;

    formData["model"] = "Institution";

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }application/project-received?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const interestsSentSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(interestsReceivedIndAPI.pending, (state) => {
      state.interestsReceivedInd = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(interestsReceivedIndAPI.fulfilled, (state, action) => {
      state.interestsReceivedInd = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(interestsReceivedIndAPI.rejected, (state, action) => {
      state.interestsReceivedInd = [];
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(interestsReceivedInsAPI.pending, (state) => {
      state.interestsReceivedIns = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(interestsReceivedInsAPI.fulfilled, (state, action) => {
      state.interestsReceivedIns = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(interestsReceivedInsAPI.rejected, (state, action) => {
      state.interestsReceivedIns = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default interestsSentSlice.reducer;
